var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"appear":"","name":"slide-in"}},[_c('aside',{staticClass:"version-info"},[_vm._v("v"+_vm._s(_vm.version))])])}
var staticRenderFns = []

export { render, staticRenderFns }